export default "__VITE_ASSET__BDnzcwQb__"